import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getKioskHardwareState = (state: GlobalState) => state[KEY];

const selectKioskHardware = createSelector(getKioskHardwareState, (hardware) => hardware.kioskHardware);

const selectAction = createSelector(getKioskHardwareState, (hardware) => hardware.action);

export const selectors = {
  selectKioskHardware,
  selectAction
};
